<div class="profile-btn" (click)="toggle()">
  <app-pixel-creature [addr]="wallet.activeAddress() ?? ''"></app-pixel-creature>
  <div class="profile-info">
    <span class="profile-name">
      <app-identity [username]="wallet.username()" [twitterHandle]="linkedHandle()" [hideTwitterLink]="true"></app-identity>
    </span>
    <span class="profile-status">
      <span class="eth">
        <span
          class="connection-dot"
          [class.connected]="isSocketConnected()"
          [class.reconnecting]="isReconnecting()"
        ></span>
        {{ scaledEthBalance() }}
      </span>
      <span class="pts"><span class="gacha-icon">☀</span>{{ onchainState.pointsBalance() }}</span>
    </span>
  </div>
  <svg class="settings-gear" [class.open]="isOpen()" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path fill="currentColor" d="M19.14 12.94a7.49 7.49 0 0 0 .05-.94 7.49 7.49 0 0 0-.05-.94l2.03-1.58a.5.5 0 0 0 .12-.63l-1.92-3.32a.5.5 0 0 0-.6-.22l-2.39.96a7 7 0 0 0-1.62-.94l-.36-2.54a.5.5 0 0 0-.5-.42h-3.84a.5.5 0 0 0-.5.42l-.36 2.54a7 7 0 0 0-1.62.94l-2.39-.96a.5.5 0 0 0-.6.22L2.67 8.85a.5.5 0 0 0 .12.63l2.03 1.58a7.49 7.49 0 0 0 0 1.88L2.79 14.52a.5.5 0 0 0-.12.63l1.92 3.32a.5.5 0 0 0 .6.22l2.39-.96a7 7 0 0 0 1.62.94l.36 2.54a.5.5 0 0 0 .5.42h3.84a.5.5 0 0 0 .5-.42l.36-2.54a7 7 0 0 0 1.62-.94l2.39.96a.5.5 0 0 0 .6-.22l1.92-3.32a.5.5 0 0 0-.12-.63l-2.03-1.58zM12 15.5A3.5 3.5 0 1 1 15.5 12 3.5 3.5 0 0 1 12 15.5z"/>
  </svg>
</div>

@defer (on idle) {
  @if (isOpen()) {
    <div class="dropdown-panel">
      <app-profile-settings-sections
        (dismiss)="isOpen.set(false)"
        (moreSettings)="openSettings()"
      />
    </div>
  }
}

@defer (on idle) {
  @if (showSettings()) {
    <app-settings-modal (closed)="closeSettings()" />
  }
}
